import { Theme, makeStyles } from '@material-ui/core';

export const useVirtualTableStyles = makeStyles<
  Theme,
  {
    wrapperClick: boolean;
    height: number;
    isSafari: boolean;
    newDesign: boolean;
  }
>({
  wrapper: {
    cursor: ({ wrapperClick }) => wrapperClick && 'pointer',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    borderCollapse: 'collapse'
  },
  tbody: {
    display: 'flex',
    flexDirection: 'column',
    height: ({ height }) => (height ? `${height}px` : '100%'),
    width: '100%',
    position: 'relative'
  },
  table: {
    borderCollapse: 'collapse',
    position: ({ isSafari }) => (isSafari ? 'relative' : 'inherit')
  },
  newDesignWrapper: {
    borderRadius: ({ newDesign }) => (newDesign ? '20px !important' : 0),
    transition: ({ newDesign }) => (newDesign ? 'all 0.3s ease-in-out' : 'none')
  }
});
